import { render, staticRenderFns } from "./NoResultsIcon.vue?vue&type=template&id=74942746&scoped=true&"
var script = {}
import style0 from "./NoResultsIcon.vue?vue&type=style&index=0&id=74942746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74942746",
  null
  
)

export default component.exports